import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
	selector: 'jepto-ui-progress-bar-indeterminate',
	standalone: true,
	imports: [CommonModule, MatProgressBarModule],
	templateUrl: './jepto-ui-progress-bar-indeterminate.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrl: './jepto-ui-progress-bar-indeterminate.component.scss',
})
export class JeptoUiProgressBarIndeterminateComponent {
	@Input() color: 'primary' | 'accent' | 'warn' = 'primary';
	@Input() bufferValue: number = 0;
	@Input() value: number = 0;
	@Input() mode: 'determinate' | 'indeterminate' | 'buffer' | 'query' =
		'indeterminate';
}
